module.exports = __webpack_public_path__ + "static/img/01.3674242.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/01.png
// module id = 2uN1
// module chunks = 1